/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export const $DoctorSpecialtyType = {
  type: 'Enum',
} as const;
